module.exports = __webpack_public_path__ + "1e2dd1403f857ee1023b50accca9f49d.svg";